// @ts-check

const NEWS_SLUG_MAX_LENGTH = 80;

/**
 * @param {string} title
 */
function createNewsSlug(title) {
  const slug = String(title || '')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, '');

  const truncatedSlug = Array.from(slug)
    .slice(0, NEWS_SLUG_MAX_LENGTH)
    .join('')
    .replace(/-+$/g, '');

  return truncatedSlug || 'news';
}

/**
 * @param {{ idx: string | number; title: string }} article
 */
function buildNewsArticleSegment(article) {
  return `${article.idx}-${createNewsSlug(article.title)}`;
}

/**
 * @param {{ idx: string | number; title: string }} article
 */
function buildNewsArticlePath(article) {
  return `/about/news/${buildNewsArticleSegment(article)}`;
}

/**
 * @param {string} segment
 * @returns {string | null}
 */
function parseNewsArticleId(segment) {
  const match = /^([1-9]\d*)(?:-.+)?$/.exec(segment);

  return match?.[1] ?? null;
}

module.exports = {
  buildNewsArticlePath,
  buildNewsArticleSegment,
  createNewsSlug,
  parseNewsArticleId,
};
